module.exports = __webpack_public_path__ + "static/maxim-valcke.349376bc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/maxim-valcke.jpg
// module id = 671
// module chunks = 168707334958949